export default __webpack_public_path__ + "static/repurpose-8b23f85acab2b9a565dd26628ceb5578.svg";